import { lumi } from '@/lib/lumi'

/**
 * Upload helper utilisant lumi.tools.file.upload.
 * Renvoie l'URL OSS du fichier uploadé, ou null en cas d'erreur.
 */
export async function uploadOneFile(file: File): Promise<string | null> {
  try {
    const results = await lumi.tools.file.upload([file])
    const first = results?.[0]
    if (first?.fileUrl) {
      console.log('[upload] OK', first.fileName, '→', first.fileUrl)
      return first.fileUrl
    }
    console.warn('[upload] failed:', first?.uploadError || 'unknown')
    return null
  } catch (err) {
    console.error('[upload] exception:', err)
    return null
  }
}

/**
 * Upload une liste de fichiers en parallèle. Renvoie un map fileName → URL.
 * Les fichiers en échec sont simplement omis du résultat.
 */
export async function uploadManyFiles(
  files: File[]
): Promise<Record<string, string>> {
  if (files.length === 0) return {}
  try {
    const results = await lumi.tools.file.upload(files)
    const map: Record<string, string> = {}
    results.forEach((r) => {
      if (r.fileUrl) map[r.fileName] = r.fileUrl
      else console.warn('[upload] skipped', r.fileName, r.uploadError)
    })
    return map
  } catch (err) {
    console.error('[upload] batch exception:', err)
    return {}
  }
}
